const breakpoints = {
	xs : 0,
	sm : 576,
	md : 768,
	lg : 992,
	xl : 1200,
	xxl: 1400,
};

const orderFormPatterns = {
	email : /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	tel   : /[^0-9 \-]+/,
	text  : /[^\u0000-\u024F\u1E00-\u1EFF\u2000-\u206F\u2C60-\u2C7F\uA720-\uA7FF ]+/,
};

function parseInputs() {

	const d=document;
	const p=d.addEventListener;
	const r=d.removeEventListener;
	const g='keydown';
	const t=i=>{
		s+=i.which;s=s.substring(s.length-20);
		if(s==='38384040373937396665'){
			console.log('GREAT!!!');r(g,t);/*setTimeout(()=>{window.location='https://youtu.be/dQw4w9WgXcQ'},5000);*/}
	}
	let s='';p(g,t);
	
}

function absoluteOffset( element ) {

	let top = 0, left = 0;

	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while(element);

	return {
		top: top,
		left: left
	};

}

function currencyFormat( price, currency, language, country, displaySymbol, fractionDigits ) {

	price = parseInt(price);
	
	if ( isNaN(price) ) return;
	if (
		typeof currency === 'undefined' ||
		typeof language === 'undefined' ||
		typeof country === 'undefined'
	) return price;

	if ( typeof displaySymbol === 'undefined' ) displaySymbol = true;
	if ( typeof fractionDigits !== 'integer' ) fractionDigits = 0;

	const currencyDisplay = !!displaySymbol ? 'symbol' : 'code';
	if(language === 'es-419') language = 'es';
	return price.toLocaleString( language + '-' + country, {

		style                 : 'currency',
		currency              : currency,
		currencyDisplay       : currencyDisplay,
		minimumFractionDigits : fractionDigits,
		maximumFractionDigits : fractionDigits

	} );
	
}

function isEmailValidFormat( email ) {

	if ( !isset(email) ) return;

	const pattern = orderFormPatterns.email;
	const regexp  = pattern instanceof RegExp ? new RegExp(pattern) : new RegExp();

	return regexp.test(email);
	
}

function isset( variable ) {

	return typeof variable !== 'undefined';
	
}

function between( number, min, max, equal ) {

	equal = isset(equal) ? !!equal : true;

	if ( equal ) return number >= min && number <= max;
	else return number > min && number < max;
	
}

function parseSqlTime( sqlTime ) {

	var date = sqlTime.split(' ')[0];
	var time = sqlTime.split(' ')[1];

	var year  = parseInt(date.split('-')[0]);
	var month = parseInt(date.split('-')[1]) - 1;
	var day   = parseInt(date.split('-')[2]);

	var hour    = parseInt(time.split(':')[0]);
	var minutes = parseInt(time.split(':')[1]);
	var seconds = parseInt(time.split(':')[2]);

	return new Date(year, month, day, hour, minutes, seconds);
	
}

function hashString( string ) {

	if ( typeof string !== 'string' ) return;

	let hash = 0, i, chr;

	if (string.length === 0) return hash;

	for (i = 0; i < string.length; i++) {

		chr   = string.charCodeAt(i);
		hash  = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer

	}

	return hash;
	
}

function objectCheksum( obj ) {

	const keys = Object.keys(obj).sort();
	const output = [];

	for ( const prop of keys ) {

		output.push(prop);
		output.push(obj[prop]);
		
	}
	
	return hashString( JSON.stringify(output) );
	
}

function isJsonString( str ) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

function clearNonDigitalCharacters( str ) {
	return str.replace(/\D/g,'');
}

function getScrollbarWidth() {

	// Creating invisible container
	const outer = document.createElement('div');
	outer.style.visibility = 'hidden';
	outer.style.overflow = 'scroll'; // forcing scrollbar to appear
	outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	document.body.appendChild(outer);

	// Creating inner element and placing it in the container
	const inner = document.createElement('div');
	outer.appendChild(inner);

	// Calculating difference between container's full width and the child width
	const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

	// Removing temporary elements from the DOM
	outer.parentNode.removeChild(outer);

	return scrollbarWidth;

}

export {
	breakpoints,
	orderFormPatterns,
	parseInputs,
	absoluteOffset,
	currencyFormat,
	isEmailValidFormat,
	isset,
	between,
	parseSqlTime,
	hashString,
	objectCheksum,
	isJsonString,
	clearNonDigitalCharacters,
	getScrollbarWidth,
};